import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from '@data/data.service';
import { ColDef } from '@grid/grid-types';
import {
  getRowStyle,
  OrdersGridComponent,
} from '@grid/orders-grid/orders-grid.component';
import { EditCellRendererComponent } from '@grid-cell/edit-cell-renderer.component';
import { ToolbarService } from '@toolbar/toolbar.service';
import { getAddressParts } from '../../partners/partners/partners.component';
import { trimString } from '../../util/utils';
import { BackendPaths } from '@common/backend-paths';
import {
  filterCustomer,
  GridColumnStyles,
  MyLog,
  setRawPhones,
  splitSearchValue,
} from '@common/common';

const editColumn: ColDef = {
  //headerClass: 'table-edit-column-header',
  headerName: '',
  width: 75,
  minWidth: 60,
  cellClass: 'tablan-edit-cell',
  cellRenderer: EditCellRendererComponent,
  cellRendererParams: {
    url: '/customers/',
    canEdit: true
  },
  pinned: 'right',
};

const partnerNrColumn = {
  field: 'id',
  headerName: 'ID',
  minWidth: 100,
};

const partnerNameColumn = {
  field: 'name',
  headerName: 'Name',
  minWidth: 200,
  flex: 1,
};

const addressColumn = {
  field: 'addr',
  headerName: 'Adresse',
  cellRenderer: function (param: any) {
    const parts = getAddressParts(param);
    return parts.join('<br>');
  },
  minWidth: 200,
  flex: 1,
};

const contactColumn = {
  field: 'contact',
  headerName: 'Kontakt',
  cellRenderer: function (param: any) {
    const item = param.data;
    const res: any[] = [];
    const tel = ''; //'&#128222; ';
    if (item.phone) {
      res.push(tel + item.phone);
    }
    if (item.mobile) {
      res.push(tel + item.mobile);
    }
    if (res.length > 0) {
      return res.join('<br>');
    }
    return '';
  },
  minWidth: 200,
  flex: 1,
};

const partnerColumn = {
  field: 'partner',
  headerName: 'Partner',
  minWidth: 200,
  flex: 1,
};

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
})
export class CustomersComponent implements OnInit {
  gridOptions: any = {
    defaultColDef: {
      headerClass: 'def-col',
      autoHeight: true,
      cellClass: GridColumnStyles.CELL_CLASS_STRING,
    },
    columnDefs: [
      partnerNrColumn,
      partnerNameColumn,
      addressColumn,
      contactColumn,
      partnerColumn,
      editColumn,
    ],
    scrollbarWidth: 20,
    enableCellTextSelection: true,
    alwaysShowHorizontalScroll: true,
    alwaysShowVerticalScroll: true,
    //getRowHeight: getRowHeight,
    getRowStyle,
  };

  rows: any = [];

  onFilterChange($event: any) {
    if (this._grid) {
      const val = trimString($event).toLowerCase();

      if (val) {
        const vals = splitSearchValue(val);

        const newRows = this.rows.filter((item: any) => {
          return filterCustomer(item, vals);
        });
        MyLog.log('Filter:', this.rows.length, newRows.length, vals);
        this._grid.setRowData(newRows);
      } else {
        this._grid.setRowData(this.rows);
      }
    }
  }

  private _grid!: OrdersGridComponent;

  @ViewChild('grid', {
    read: OrdersGridComponent,
  })
  set grid(grid: OrdersGridComponent) {
    this._grid = grid;
    grid && grid.setGridOptions(this.gridOptions);
  }

  constructor(
    private data: DataService,
    private toolbarService: ToolbarService
  ) { }

  ngOnInit(): void {
    this.toolbarService.setTitle('Kunden');

    this.data.get(BackendPaths.CUSTOMERS).subscribe((result: any) => {
      const res = result?.result;

      if (Array.isArray(res?.rows)) {
        const rows = res.rows;

        /*
        const rs = JSON.stringify(rows);
        let es = '';
        let rms = '';
        let sms = '';
        if (res.encoded) {
          es = JSON.stringify(res.encoded);
          MyLog.log('ENC:', res.encoded);
        }
        if (res.rowMap) {
          rms = JSON.stringify(res.rowMap);
        }
        if (res.subMap) {
          sms = JSON.stringify(res.subMap);
          MyLog.log('SUBMAP:', res.subMap);
        }
        MyLog.log('RS:', rs.length);
        MyLog.log('ES:', es.length);
        MyLog.log('RM:', rms.length);
        MyLog.log('SM:', sms.length);
        const pc = (es.length + rms.length + sms.length) / rs.length;
        MyLog.log('SAVE:%:', ((pc) * 100).toFixed(2));
        */

        rows.forEach((item: any) => {
          item.name = trimString((item.fname || '') + ' ' + (item.lname || ''));
          item.addr =
            (item.address || '') +
            '\n ' +
            (item.zip || '') +
            '\n ' +
            (item.city || '');

          item.partner = (item.pf || '') + ' ' + (item.pl || '');
          setRawPhones(item);
        });

        this.rows = rows;
        const grid = this._grid;
        grid && grid.setRowData(this.rows);
      }
    });
  }
}
